/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import AppointmentStatus from './appointment-status';
import AppointmentStatusDetail from './appointment-status-detail';
import AppointmentStatusUpdate from './appointment-status-update';
import AppointmentStatusDeleteDialog from './appointment-status-delete-dialog';

const AppointmentStatusRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<AppointmentStatus />} />
    <Route path="new" element={<AppointmentStatusUpdate />} />
    <Route path=":id">
      <Route index element={<AppointmentStatusDetail />} />
      <Route path="edit" element={<AppointmentStatusUpdate />} />
      <Route path="delete" element={<AppointmentStatusDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default AppointmentStatusRoutes;
